import { LayoutInvoiceExport } from './Layout/LayoutInvoiceExport'
export const InvoiceExportScreen = () => {
  return (
    <LayoutInvoiceExport />
  )
}
